import { render, staticRenderFns } from "./wuhu.vue?vue&type=template&id=17e648c6&scoped=true"
import script from "./wuhu.vue?vue&type=script&lang=js"
export * from "./wuhu.vue?vue&type=script&lang=js"
import style0 from "./wuhu.vue?vue&type=style&index=0&id=17e648c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e648c6",
  null
  
)

export default component.exports